// Date helpers. Calendar-day values travel as 'YYYY-MM-DD' (DATEONLY) and must
// NOT pass through `new Date()` for display — that parses as UTC midnight and
// shifts a day in negative-offset zones (the "día anterior" bug). Format
// straight from the string. Pattern mirrored from cowre.ultimate.dashboard.

export function formatDateOnly(value) {
    if (!value) return '';
    const [y, m, d] = String(value).slice(0, 10).split('-');
    if (!y || !m || !d) return value;
    return `${d}/${m}/${y}`;
}

// Whole days between two wall-clock dates (b − a). Both parsed as UTC midnight
// so the subtraction yields exact day counts regardless of the local zone.
export function daysBetween(a, b) {
    if (!a || !b) return null;
    const ms = Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`);
    return Number.isNaN(ms) ? null : Math.round(ms / 86400000);
}

// Today as 'YYYY-MM-DD' in the LOCAL zone (en-CA locale formats ISO-like).
export function todayStr() {
    return new Date().toLocaleDateString('en-CA');
}

// dateStr + n days → 'YYYY-MM-DD'. UTC arithmetic, no zone drift.
export function addDays(dateStr, n) {
    const base = Date.parse(`${String(dateStr).slice(0, 10)}T00:00:00Z`);
    if (Number.isNaN(base)) return dateStr;
    return new Date(base + n * 86400000).toISOString().slice(0, 10);
}

// Liquidation period → human label. Accepts 'YYYY-MM' or (year, month).
// No `new Date()` parsing (see header note) — month name from a fixed table.
const MONTHS_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

export function periodLabel(yearOrPeriod, month) {
    let y = yearOrPeriod;
    let m = month;
    if (m == null && typeof yearOrPeriod === 'string') {
        [y, m] = yearOrPeriod.split('-').map(Number);
    }
    const name = MONTHS_ES[Number(m) - 1];
    return name ? `${name} ${y}` : String(yearOrPeriod ?? '');
}

// 'hoy' / 'hace N d' / 'en N d' relative to today (wall-clock).
export function relativeDayLabel(dateStr) {
    if (!dateStr) return '';
    const diff = daysBetween(todayStr(), dateStr);
    if (diff == null) return '';
    if (diff === 0) return 'hoy';
    if (diff < 0) return `hace ${Math.abs(diff)} d`;
    return `en ${diff} d`;
}
